<template>
  <div class="tvprogram-block">
    <h4 class="tvprogram-block-title" :title="block.title"><span>{{ block.title }}</span>{{ block.from }}-{{ block.to }} Uhr{{host}}</h4>
    <ul v-if="block.hasOffers">
      <li v-for="(offer) in block.offers">
        <tv-program-offer v-bind:offer="offer"/>
      </li>
    </ul>
  </div>
</template>

<script>

import {store} from "./TvProgramStore";
import TvProgramOffer from "./TvProgramOffer.vue";

export default {
  name: 'TvProgramBlock',
  data: () => {
    return {
      store
    }
  },
  components: {
    TvProgramOffer
  },
  computed: {
    block() {
      return this.$attrs.block;
    },
    host() {
      if (this.block.host !== '') {
        return ` mit ${this.block.host}`;
      }
      return '';
    }
  },
  created() {
  },
  mounted() {
  },
  methods: {}
}
</script>

<style lang="scss">
</style>